import { resolveVisibilityFlag } from './showPriceDiscounts';

/**
 * Whether the delivery cost line should appear on orders, invoices, and share text.
 * Display-only: totals still include delivery when it is hidden.
 */
export function shouldShowDeliveryCost(...sources) {
    return resolveVisibilityFlag('show_delivery_cost', sources);
}

export default shouldShowDeliveryCost;
